import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AdminViewComponent } from "./admin-view.component";
import { TableName } from "src/app/npr-request.model";
import { ApiService } from "src/app/services";
import { ModalService } from "src/app/shared/modal.service";
import { EdgeZoneColumnDefinitionForAdmin } from "./ag-grid-column-definition";
import { DataTypes } from "./admin-view-data-types";
import { SharedDataService } from "../../services/sharedDataService";
import { EdgeZoneConfig } from "../../generated-models/EdgeZoneConfig";

@Component({
  standalone: false,
  selector: "admin-view/edgezone",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["../../styles.scss"],
})
export class AdminViewEdgeZoneComponent extends AdminViewComponent<EdgeZoneConfig> implements OnInit {
  type = "EdgeZone";
  tableName = TableName.EdgeZone;
  columnDef = EdgeZoneColumnDefinitionForAdmin;
  keyFilterStats = "filter:admin-view-edgezone";

  constructor(
    apiService: ApiService,
    modalService: ModalService,
    notificationService: ToastrService,
    sharedDataService: SharedDataService,
    dataTypes: DataTypes
  ) {
    super(apiService, modalService, notificationService, sharedDataService, dataTypes);
    this.addRowEnable = true;
    this.addRowFunc = (data: EdgeZoneConfig) => apiService.setEdgeZoneConfig(data).toPromise();
    this.updateRowFunc = (data: EdgeZoneConfig) => apiService.setEdgeZoneConfig(data).toPromise();
    this.deleteRowEnable = true;
    this.deleteRowFunc = (data: EdgeZoneConfig) => apiService.deleteEdgeZoneConfig(data).toPromise();
  }

  refreshData() {
    super.refreshData();
    this.apiService.getEdgeZoneConfig().subscribe((response) => {
      this.setRowData(response);
      super.setupFilterByLocalData();
    });
  }
}
